// extracted by mini-css-extract-plugin
module.exports = {"formStyle":"styles_formStyle__2NHKP"};